import Vue from 'vue';

// When the request succeeds
const success = (response, context) => {
  context.forms = response.data.forms;
  context.steps = response.data.steps;

  if (context.steps && context.formSteps) {
    const checkinForm = context.forms.find(form => form.type.name === 'checkin');
    if (checkinForm) {
      context.steps.map(step => {
        context.formSteps[step.id] = checkinForm.steps.some(formStep => formStep.id === step.id);
      });
    }
  }
};

// When the request fails
const failed = (error, context) => {
  toastr.error(error);
};

export default (context, rental_id) => {
  return Vue.$http.get('/forms/' + rental_id)
    .then((response) => {
      if (response && response.status === 200) {
        success(response, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/form/get.js